// extracted by mini-css-extract-plugin
export default {"filter-column-height":"orderHistoryFilterbox_filter-column-height__x4cRM"};